import { FiArrowUpRight, FiGithub, FiLinkedin, FiMail } from "react-icons/fi";
import Reveal from "../ui/Reveal";

const channels = [
  {
    Icon: FiMail,
    label: "Email",
    value: "demajalbina3@gmail.com",
    href: "mailto:demajalbina3@gmail.com",
    cta: "Write to me",
  },
  {
    Icon: FiLinkedin,
    label: "LinkedIn",
    value: "Albina Demaj",
    href: "https://www.linkedin.com/in/albina-demaj-881293300/",
    cta: "Connect",
  },
  {
    Icon: FiGithub,
    label: "GitHub",
    value: "@albinademaj",
    href: "https://github.com/albinademaj",
    cta: "Browse the code",
  },
];

const Contact = () => (
  <section id="contact" className="grain section relative overflow-hidden bg-ink">
    <div className="grid-lines absolute inset-0 opacity-50" />
    <div className="pointer-events-none absolute left-1/2 top-0 h-[520px] w-[720px] -translate-x-1/2 rounded-full glow-moss" />

    <div className="shell relative">
      <div className="max-w-4xl">
        <Reveal>
          <div className="flex items-center gap-4">
            <span className="eyebrow text-sage/70">05</span>
            <span className="h-px w-10 bg-sage/40" />
            <span className="eyebrow text-mint">Contact</span>
          </div>
        </Reveal>

        <Reveal delay={0.08}>
          <h2 className="display mt-6 text-[2.8rem] leading-[1.02] text-cream sm:text-[4rem] md:text-[5rem]">
            Let’s build something{" "}
            <em className="text-gradient italic">worth using.</em>
          </h2>
        </Reveal>

        <Reveal delay={0.16}>
          <p className="mt-7 max-w-2xl text-[1.05rem] leading-8 text-cream/55">
            I’m open to internships, freelance work and full-stack roles. Tell
            me what you’re building — I usually reply within a day.
          </p>
        </Reveal>
      </div>

      {/* Oversized email line */}
      <Reveal delay={0.1}>
        <a
          href="mailto:demajalbina3@gmail.com"
          className="group mt-14 flex flex-wrap items-center justify-between gap-6 border-y border-cream/10 py-9 transition-colors duration-500 hover:border-mint/40"
        >
          <span className="display break-all text-[1.6rem] text-cream transition-colors duration-500 group-hover:text-mint sm:text-[2.6rem] md:text-[3.2rem]">
            demajalbina3@gmail.com
          </span>

          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-cream/15 text-xl text-cream transition duration-500 group-hover:border-mint group-hover:bg-mint group-hover:text-ink">
            <FiArrowUpRight />
          </span>
        </a>
      </Reveal>

      <div className="mt-10 grid gap-4 md:grid-cols-3">
        {channels.map((channel, index) => (
          <Reveal key={channel.label} delay={0.06 * index}>
            <a
              href={channel.href}
              target={channel.href.startsWith("http") ? "_blank" : undefined}
              rel={
                channel.href.startsWith("http")
                  ? "noopener noreferrer"
                  : undefined
              }
              className="group flex h-full flex-col rounded-3xl border border-cream/10 bg-cream/[0.03] p-7 transition duration-500 hover:-translate-y-1.5 hover:border-mint/30 hover:bg-cream/[0.06]"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-cream/10 text-lg text-mint transition-colors duration-500 group-hover:bg-mint group-hover:text-ink">
                <channel.Icon />
              </span>

              <p className="eyebrow mt-7 text-cream/40">{channel.label}</p>

              <p className="mt-2 break-all font-display text-xl text-cream">
                {channel.value}
              </p>

              <span className="mt-6 inline-flex items-center gap-2 text-[13px] font-semibold text-mint">
                {channel.cta}
                <FiArrowUpRight className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.12}>
        <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-[13px] text-cream/40">
          <span className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-sage" />
            Available for new projects
          </span>
          <span>Based in Kosovo · Working remotely</span>
          <span>Response time — under 24h</span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Contact;
